export default __webpack_public_path__ + "static/logo_circle-5c907b3fc1a46a797116cbdb4d0a9db7.png";